import styled from "styled-components";
import { EmptyButton } from "@smartsuite/react-ui/lib";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const StyledInfoButton = styled.button`
  display: inline-flex;
  height: 15px;
  margin: 0 6px;

  cursor: default;

  &.active,
  &:hover {
    svg {
      path {
        fill: ${GrayColors["G-8"]} !important;
      }
    }
  }

  svg {
    path {
      fill: ${GrayColors["G-5"]};
    }
  }
`;

export const StyledDropPanelContent = styled.div`
  width: 340px;
  padding: 23px;

  textarea {
    width: 100%;
    min-height: 80px;
    border: none;
    resize: none;
    border-radius: 5px;
    padding: 8px 10px 7px;
  }
`;

export const StyledButtonsPanel = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;

  .empty-button:active {
    color: ${SolutionColorVariables.sc1};
  }
`;

export const StyledEmptyButton = styled(EmptyButton)`
  margin-right: 10px;
`;
